export default __webpack_public_path__ + "static/media/arrows-left.74f341af.svg";